import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "diagnosis-process-top" }
const _hoisted_3 = { class: "diagnosis-process-top-contents" }
const _hoisted_4 = { class: "diagnosis-process-top-title" }
const _hoisted_5 = { class: "diagnosis-process-data-container" }
const _hoisted_6 = { class: "diagnosis-process-data-contents" }
const _hoisted_7 = { class: "item-top-wrapper" }
const _hoisted_8 = { class: "item-top-left" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "pc-only" }
const _hoisted_12 = {
  key: 0,
  class: "item-middle-wrapper"
}
const _hoisted_13 = { class: "item-no-diagnosis-process" }
const _hoisted_14 = {
  key: 1,
  class: "item-middle-wrapper"
}
const _hoisted_15 = { class: "item-middle-top" }
const _hoisted_16 = { class: "item-middle-list" }
const _hoisted_17 = { class: "item-middle-list-row" }
const _hoisted_18 = { class: "item-middle-list-row-label" }
const _hoisted_19 = { class: "item-middle-list-row-value initial-symptom-date" }
const _hoisted_20 = { class: "item-middle-list-row" }
const _hoisted_21 = { class: "item-middle-list-row-label" }
const _hoisted_22 = { class: "item-middle-list-row-value" }
const _hoisted_23 = {
  key: 0,
  class: "item-middle-bottom"
}
const _hoisted_24 = { class: "item-middle-bottom-title" }
const _hoisted_25 = { class: "item-middle-list" }
const _hoisted_26 = { class: "item-middle-list-row" }
const _hoisted_27 = { class: "item-middle-list-row-label" }
const _hoisted_28 = { class: "item-middle-list-row-value" }
const _hoisted_29 = {
  key: 0,
  class: "item-middle-list-row"
}
const _hoisted_30 = { class: "item-middle-list-row-label" }
const _hoisted_31 = { class: "item-middle-list-row-value" }
const _hoisted_32 = {
  key: 1,
  class: "item-middle-list-row"
}
const _hoisted_33 = { class: "item-middle-list-row-label" }
const _hoisted_34 = { class: "item-middle-list-row-value" }
const _hoisted_35 = {
  key: 2,
  class: "item-middle-list-row"
}
const _hoisted_36 = { class: "item-middle-list-row-label" }
const _hoisted_37 = { class: "item-middle-list-row-value" }
const _hoisted_38 = {
  key: 2,
  class: "item-bottom-wrapper"
}

import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { _$t } from "@/utils/i18n";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import DiagnosisProcessModal from "./DiagnosisProcessModal.vue";
import { DiagnosisProcess } from "@/models/myRecord/diagnosisProcess";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import { processing, processend } from "@/utils/view";

// ---- Constant ----------------------------------------------
const componentId = "healthcaredata02-03";
const menuId = "my-record";

// ---- Types -------------------------------------------------
// 初期症状の型
type InitialSymptom = {
  subNumber: number; // 枝番
  symptom: string; // 初期症状
};

// 汎用マスタの型（病院訪問数）
type HospitalVisitCountOption = {
  optionId: number; // option_id
  kubun: string; // kubun
  value: string; // value
  displayName: string; // display_name
  sortOrder: number; // sort_order
};

// 経緯データの型
type DiagnosisProcessData = {
  initialSymptomYear: string; // モーダルに渡すため文字列型
  initialSymptomMonth: string;
  initialSymptomDay: string;
  initialSymptoms: InitialSymptom[]; // 初期症状（別テーブル）
  medicalCheckupStatus: number | null; // 0: 受けていない, 1: 受けている
  diagnosisYear: string;
  diagnosisMonth: string;
  diagnosisDay: string;
  hospitalVisitsCountRangeOptionId: string; // モーダルに渡すため文字列型
  finalDiagPref: string; // 確定診断先の都道府県
  finalDiagCity: string; // 確定診断先の市区郡
  refSourcePref: string; // 紹介元の都道府県
  refSourceCity: string; // 紹介元の市区郡
  updatedAt?: string;
};

// 発症から診断までの経緯データ（病気情報を含む）
type DiseaseDetailData = {
  diseaseCode: string;
  diseaseName: string;
  diagnosisProcess: DiagnosisProcessData | null;
};

// ---- Variable ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const diseaseDetails = ref<DiseaseDetailData[]>([]);
const isDiagnosisProcessModalOpen = ref(false);
const selectedProcessData = ref<DiseaseDetailData | null>(null);
const hospitalVisitCountOptions = ref<HospitalVisitCountOption[]>([]);

// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Function ----------------------------------------------
// 戻るボタン押下
const goBack = () => {
  router.push({ name: "MyRecord" });
};

// 追加モーダルを開く
const openAddModal = (process: DiseaseDetailData) => {
  // 疾患情報のみ
  selectedProcessData.value = {
    diseaseCode: process.diseaseCode,
    diseaseName: process.diseaseName,
    diagnosisProcess: null,
  };
  isDiagnosisProcessModalOpen.value = true;
};

// 編集モーダルを開く
const openEditModal = (process: DiseaseDetailData) => {
  // 既存データをそのまま渡す（diagnosisProcessがnullでないことを確認）
  if (process.diagnosisProcess) {
    selectedProcessData.value = {
      diseaseCode: process.diseaseCode,
      diseaseName: process.diseaseName,
      diagnosisProcess: { ...process.diagnosisProcess },
    };
    isDiagnosisProcessModalOpen.value = true;
  }
};

// モーダルを閉じる
const closeDiagnosisProcessModal = async () => {
  isDiagnosisProcessModalOpen.value = false;
  selectedProcessData.value = null;

  // モーダルを閉じた後、データを再取得
  await fetchIndexData();
};

// 日付フォーマット
const formatDate = (year: string, month: string, day: string): string => {
  if (!year) return "";
  let formatted = `${year}年`;
  if (month) {
    formatted += `${month}月`;
    if (day) {
      formatted += `${day}日`;
    }
  }
  return formatted;
};

// 病院訪問数をフォーマット（汎用マスタIDから表示名へ）
const formatHospitalVisitCount = (optionId: string): string => {
  const option = hospitalVisitCountOptions.value.find(
    (opt) => opt.optionId === Number(optionId)
  );
  return option ? option.displayName : "";
};

// 更新日時フォーマット
const formatUpdateDate = (dateStr?: string): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}年${month}月${day}日`;
};

// 疾患リストと診断プロセスデータを取得
const fetchIndexData = async () => {
  const diagnosisProcessModel = new DiagnosisProcess();
  const [_model, response, err] = await diagnosisProcessModel.fetchIndexData();

  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialog.open(decodedMessage);
    return;
  }

  // APIから取得したデータを設定
  diseaseDetails.value = response.data.diseaseDetails;
  hospitalVisitCountOptions.value = response.data.hospitalVisitCountOptions;
};

onMounted(async () => {
  await fetchIndexData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, {
          activeMenu: menuId,
          previewImage: ""
        }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "diagnosis-process-top-back-button",
              onClick: goBack
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: "/server/necs/images/arrow-right_icon.png",
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_button_back")), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(_$t)("diagnosisProcess_title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diseaseDetails.value, (diseaseDetail, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "diagnosis-process-data-contents-item"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(diseaseDetail.diseaseName), 1),
                    (!diseaseDetail.diagnosisProcess)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "item-top-right",
                          onClick: ($event: any) => (openAddModal(diseaseDetail))
                        }, [
                          _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: "/server/necs/images/icon_add_circle.svg",
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_unref(_$t)("common_button_add")), 1)
                        ], 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "item-top-right",
                          onClick: ($event: any) => (openEditModal(diseaseDetail))
                        }, [
                          _cache[2] || (_cache[2] = _createElementVNode("img", {
                            class: "item-top-right-edit-icon",
                            src: "/server/necs/images/icon_edit_ec7400.svg",
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(_$t)("common_button_edit")), 1)
                        ], 8, _hoisted_10))
                  ]),
                  (!diseaseDetail.diagnosisProcess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(_$t)("diagnosisProcess_msg_no_record")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", _hoisted_16, [
                            _createElementVNode("li", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(_$t)("diagnosisProcess_label_initial_symptom_date")), 1),
                              _createElementVNode("p", _hoisted_19, _toDisplayString(formatDate(
                            diseaseDetail.diagnosisProcess.initialSymptomYear,
                            diseaseDetail.diagnosisProcess.initialSymptomMonth,
                            diseaseDetail.diagnosisProcess.initialSymptomDay
                          )), 1)
                            ]),
                            _createElementVNode("li", _hoisted_20, [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(_$t)("diagnosisProcess_label_initial_symptom")), 1),
                              _createElementVNode("p", _hoisted_22, _toDisplayString(diseaseDetail.diagnosisProcess.initialSymptoms
                            .filter((s) => s.symptom)
                            .map((s) => s.symptom)
                            .join(", ")), 1)
                            ])
                          ])
                        ]),
                        (
                    diseaseDetail.diagnosisProcess.medicalCheckupStatus === 1
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _cache[3] || (_cache[3] = _createElementVNode("img", {
                                  src: "/server/necs/images/icon_diagnosis_process_info.svg",
                                  alt: ""
                                }, null, -1)),
                                _createElementVNode("p", null, _toDisplayString(_unref(_$t)("diagnosisProcess_label_diagnosis_info")), 1)
                              ]),
                              _createElementVNode("ul", _hoisted_25, [
                                _createElementVNode("li", _hoisted_26, [
                                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(_$t)("diagnosisProcess_label_diagnosis_info_date")), 1),
                                  _createElementVNode("p", _hoisted_28, _toDisplayString(formatDate(
                            diseaseDetail.diagnosisProcess.diagnosisYear,
                            diseaseDetail.diagnosisProcess.diagnosisMonth,
                            diseaseDetail.diagnosisProcess.diagnosisDay
                          )), 1)
                                ]),
                                (
                        diseaseDetail.diagnosisProcess
                          .hospitalVisitsCountRangeOptionId
                      )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                      _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(_$t)("diagnosisProcess_label_hospital_visits_count")), 1),
                                      _createElementVNode("p", _hoisted_31, _toDisplayString(formatHospitalVisitCount(
                            diseaseDetail.diagnosisProcess
                              .hospitalVisitsCountRangeOptionId
                          )), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                        diseaseDetail.diagnosisProcess.finalDiagPref &&
                        diseaseDetail.diagnosisProcess.finalDiagCity
                      )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                      _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(_$t)("diagnosisProcess_label_final_diag_pref")), 1),
                                      _createElementVNode("p", _hoisted_34, _toDisplayString(diseaseDetail.diagnosisProcess.finalDiagPref +
                          " " +
                          diseaseDetail.diagnosisProcess.finalDiagCity), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                        diseaseDetail.diagnosisProcess.refSourcePref &&
                        diseaseDetail.diagnosisProcess.refSourceCity
                      )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                      _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(_$t)("diagnosisProcess_label_referral_received_pref")), 1),
                                      _createElementVNode("p", _hoisted_37, _toDisplayString(diseaseDetail.diagnosisProcess.refSourcePref +
                          " " +
                          diseaseDetail.diagnosisProcess.refSourceCity), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])),
                  (diseaseDetail.diagnosisProcess?.updatedAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_update_time.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(formatUpdateDate(diseaseDetail.diagnosisProcess.updatedAt)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          activeMenu: menuId
        })
      ])
    ]),
    (isDiagnosisProcessModalOpen.value && selectedProcessData.value)
      ? (_openBlock(), _createBlock(DiagnosisProcessModal, {
          key: 0,
          initialData: selectedProcessData.value,
          hospitalVisitCountOptions: hospitalVisitCountOptions.value,
          onClose: closeDiagnosisProcessModal,
          onUpdateList: fetchIndexData
        }, null, 8, ["initialData", "hospitalVisitCountOptions"]))
      : _createCommentVNode("", true),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 1 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})